import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SlickCarouselUtilService {
  defaultConfig: any;
  constructor() {
    this.defaultConfig = {
      slidesToShow: 6,
      slidesToScroll: 6,
      dots: false,
      infinite: false,
      variableWidth: false,
      draggable: false,
      prevArrow: '<button class="slick-prev-btn material-icons">keyboard_arrow_left</button>',
      nextArrow: '<button class="slick-next-btn material-icons">keyboard_arrow_right</button>',
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: false,
            draggable: true,
            variableWidth: true,
          },
        },
        {
          breakpoint: 845,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false,
            draggable: true,
            variableWidth: true,
          },
        },
        {
          breakpoint: 577,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            draggable: true,
            variableWidth: true,
          },
        },
      ],
    };
  }
}
